export default "__VITE_ASSET__pF4DA3F8__"